import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'
import store from '@/store'

export async function sendPasswordReset(email, language = null) {
    if (store.state.config?.passwordResetViaFunctions) {
        try {
            const fn = firebase.functions().httpsCallable('httpAuth-sendPasswordResetEmail')
            await fn({ email, language: language || undefined, app: 'builder' })
            return
        } catch (err) {
            console.log('sendPasswordReset via functions failed, fallback to native', err)
        }
    }

    await firebase.auth().sendPasswordResetEmail(email)
}
